import {FirebaseError} from "@firebase/util";
import {OAuthCredential} from "@firebase/auth";
import {getLoginProvider} from "../domain/login";
import {AuthProviderType} from "../domain/providers";
import {FacebookAuthProvider, GoogleAuthProvider, OAuthProvider} from "firebase/auth";

export const getCredentialFromError = (err: FirebaseError): OAuthCredential | null => {
  const loginProvider = getLoginProvider();
  if (!loginProvider) {
    throw new Error("No login provider, unable to get credential from error");
  }
  if (loginProvider === AuthProviderType.Facebook) {
    return FacebookAuthProvider.credentialFromError(err);
  }
  if (loginProvider === AuthProviderType.Google) {
    return GoogleAuthProvider.credentialFromError(err);
  }
  return OAuthProvider.credentialFromError(err);
}